exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".modalFooter-bd3d7{display:flex;justify-content:space-between}", ""]);

// Exports
exports.locals = {
	"modalFooter": "modalFooter-bd3d7"
};